import { createSlice } from "@reduxjs/toolkit";

// messageType: "popup" -> show paywall popup, "message" -> show corner snackbar
// popupType: "essentials", "prestige", etc. - which paywall to show
export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState: {
    visible: false,
    type: "" as any,
    message: "",
    screen: undefined as any,
    panel: "",
    messageType: "" as "popup" | "message" | "",
    popupType: "" as string,
    popupReason: "" as "credits" | "permissions" | "plan_change" | "",
    // REF-5453: 402 credit-gate shortfall numbers (null when BE omits them)
    requiredCredits: null as number | null,
    remainingCredits: null as number | null,
  },
  reducers: {
    showSnackbar: (state, payload) => {
      state.visible = true;
      state.type = payload.payload.type;
      state.message = payload.payload.message ?? "";
      state.screen = payload.payload.screen;
      state.panel = payload.payload.panel ?? "";
      state.messageType = payload.payload.messageType ?? "";
      state.popupType = payload.payload.popupType ?? "";
      state.popupReason = payload.payload.popupReason ?? "";
      state.requiredCredits = payload.payload.requiredCredits ?? null;
      state.remainingCredits = payload.payload.remainingCredits ?? null;
    },
    hideSnackbar: (state) => {
      state.visible = false;
    },
  },
  extraReducers: {},
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;
